import React from "react";
import { Search } from "@mui/icons-material";
import { IconButton, Button, Typography, InputAdornment } from "@mui/material";
import {
  GridToolbarDensitySelector,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";
import FlexBetween from "./FlexBetween";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { format } from "date-fns";
import { GetApp } from "@mui/icons-material";
import logo from "../assets/vetumnata_logo.jpeg";

const DataGridCustomToolbar = ({
  searchInput,
  setSearchInput,
  setSearch,
  columns,
  rowData,
}) => {
  //pdf download
  const handleDownloadPDF = () => {
    const doc = new jsPDF();

    // Add logo to PDF
    const imgData = new Image();
    imgData.src = logo;

    imgData.onload = () => {
      doc.addImage(
        imgData,
        "PNG",
        (doc.internal.pageSize.getWidth() - 50) / 2,
        10,
        20,
        20
      );
      // Adjust the position and size of the logo as needed

      // Extract columns dynamically
      const pdfColumns = columns.map((col) => ({
        header: col.headerName,
        dataKey: col.field,
      }));

      // Map row data according to columns
      const pdfRows = rowData.map((row) => {
        const formattedRow = {};
        columns.forEach((col) => {
          if (col.field === "createdAt" || col.field === "updatedAt") {
            formattedRow[col.field] = format(
              new Date(row[col.field]),
              "yyyy-MM-dd"
            );
          } else {
            formattedRow[col.field] = row[col.field];
          }
        });
        return formattedRow;
      });
      doc.autoTable({
        columns: pdfColumns,
        body: pdfRows,
        startY: 40, // Adjust the startY value to leave space for the logo
        theme: "grid",
      });

      doc.save("Bhetamana.pdf");
    };
  };

  return (
    <GridToolbarContainer>
      <FlexBetween width="100%">
        <FlexBetween>
          <GridToolbarColumnsButton />
          <GridToolbarDensitySelector />
          <GridToolbarExport />
          <IconButton onClick={handleDownloadPDF}>
            <GetApp />
            <Typography variant="body2">Download PDF</Typography>
          </IconButton>
        </FlexBetween>
      </FlexBetween>
    </GridToolbarContainer>
  );
};

export default DataGridCustomToolbar;
